module.exports = __webpack_public_path__ + "static/media/maagdarm.7b78b2bb.svg";